

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETSUBDEPARTMENTDBYID= createAsyncThunk(
  "getSubDepartmentById/getSubDepartmentById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getSubDepartmentByIdSlice = createSlice({
  name: "getSubDepartmentByIdSlice",
  initialState: {
    getSubDepartmentById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetSubDepartmentById: (state) => {
        state.getSubDepartmentById.loading = false
        state.getSubDepartmentById.error = false
        state.getSubDepartmentById.data = []
        state.getSubDepartmentById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETSUBDEPARTMENTDBYID.fulfilled, (state, action) => {
      state.getSubDepartmentById = {
        ...state.getSubDepartmentById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETSUBDEPARTMENTDBYID.pending, (state, action) => {
      state.getSubDepartmentById = {
        ...state.getSubDepartmentById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETSUBDEPARTMENTDBYID.rejected, (state, action) => {
      state.getSubDepartmentById = {
        ...state.getSubDepartmentById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getSubDepartmentByIdAction = {
    GETSUBDEPARTMENTDBYID,
};

export { getSubDepartmentByIdAction };
export default getSubDepartmentByIdSlice.reducer;
export const {setInitialStateOfgetSubDepartmentById} = getSubDepartmentByIdSlice.actions
